import * as tslib_1 from "tslib";
import { ESRI } from '../esri-loader-util';
import * as i0 from "@angular/core";
var LegendService = /** @class */ (function () {
    function LegendService() {
        this.hardcodedLayerId = 4;
        this.promisedColors = [];
    }
    LegendService.prototype.getDefaultColors = function () {
        var max = 255;
        var zero = 0;
        var fifth = 53;
        var third = 75;
        var overHundred = 117;
        var half = 153;
        var twoThrid = 190;
        var dim = 11;
        var defaultColors = [
            [max, zero, zero],
            [zero, max, zero],
            [zero, zero, max],
            [max, half, zero],
            [half, zero, max],
            [zero, max, max],
            [max, zero, max],
            [max, max, zero],
            [half, zero, zero],
            [fifth, overHundred, dim],
            [dim, third, half],
            [twoThrid, third, dim],
            [fifth, dim, overHundred],
            [dim, third, third],
            [overHundred, dim, third],
            [twoThrid, half, zero]
        ];
        return defaultColors;
    };
    LegendService.prototype.getLayerLegend = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, layerId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (layer !== null && layer !== undefined) {
                            url = layer.url + '/legend?f=json';
                            layerId = layer.layerId;
                        }
                        else {
                            // TODO: hardcode for now until map layers can be avaialbe from  map
                            url = 'https://www.dotdev7.state.pa.us/penndotgis/rest/services/GISUSER/GISUSER/MapServer/legend?f=json';
                            layerId = this.hardcodedLayerId;
                        }
                        return [4 /*yield*/, this.getLegendByLayerId(url, layerId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LegendService.prototype.getLayerLegendByLayerId = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = 'https://www.dotdev7.state.pa.us/penndotgis/rest/services/GISUSER/GISUSER/MapServer/legend?f=json';
                        return [4 /*yield*/, this.getLegendByLayerId(url, layerId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LegendService.prototype.esriConfig = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Config];
                    case 1:
                        config = _a.sent();
                        this.getCorsEnabledHosts().forEach(function (host) {
                            config.request.corsEnabledServers.push(host); // To be deprecated: http://esriurl.com/cors8664
                            // Replace with 'trustedServers' property on request:
                            // https://developers.arcgis.com/javascript/latest/api-reference/esri-config.html#request
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    LegendService.prototype.getEsriColor = function (color) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Color;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ESRI.loadModules('esri/Color')];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), Color = _a[0];
                        if (!color) {
                            return [2 /*return*/, null];
                        }
                        else if (color.declaredClass === 'esri.Color') {
                            return [2 /*return*/, color];
                        }
                        else if (typeof color === 'string') {
                            if (color.indexOf('rgb') === 0) {
                                return [2 /*return*/, Color.fromRgb(color)];
                            }
                            else {
                                return [2 /*return*/, Color.fromString(color)];
                            }
                        }
                        else if (Array.isArray(color)) {
                            return [2 /*return*/, new Color(color)];
                        }
                        else if (color.r !== undefined && color.g !== undefined && color.b !== undefined) {
                            return [2 /*return*/, new Color([color.r, color.g, color.b, color.a])];
                        }
                        else {
                            return [2 /*return*/, new Color()];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LegendService.prototype.getLegendByLayerId = function (serviceUrl, layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var esriRequest, resp, legendLyr, legend;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.esriConfig()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, ESRI.Request];
                    case 2:
                        esriRequest = (_a.sent());
                        return [4 /*yield*/, esriRequest(serviceUrl, {
                                responseType: 'json'
                            })];
                    case 3:
                        resp = _a.sent();
                        legendLyr = resp.data.layers.find(function (lyr) { return lyr.layerId === layerId; });
                        if (legendLyr && legendLyr.legend[0]) {
                            legend = legendLyr.legend[0];
                            if (legend.imageData.length > 0) {
                                return [2 /*return*/, "data:" + legend.contentType + ";base64," + legend.imageData];
                            }
                            else {
                                return [2 /*return*/, ''];
                            }
                        }
                        return [2 /*return*/, ''];
                }
            });
        });
    };
    LegendService.prototype.getNewColor = function (map, skip) {
        var _this = this;
        if (skip) {
            return [0, 0, 0];
        }
        var existingColors = this.getExistingLayerColors(map);
        var defaultColors = this.getDefaultColors();
        var newColor = defaultColors.find(function (_a) {
            var _b = tslib_1.__read(_a, 3), r = _b[0], g = _b[1], b = _b[2];
            return !existingColors.find(function (_a) {
                var _b = tslib_1.__read(_a, 3), x = _b[0], y = _b[1], z = _b[2];
                return r === x && g === y && b === z;
            })
                && !_this.promisedColors.find(function (_a) {
                    var _b = tslib_1.__read(_a, 3), x = _b[0], y = _b[1], z = _b[2];
                    return r === x && g === y && b === z;
                });
        }) || this.getRandomColorRGB();
        this.promisedColors.push(newColor);
        this.promisedColorsTimeout = setTimeout(function () { return _this.promisedColors = []; }, 1000);
        return newColor;
    };
    LegendService.prototype.getRandomColor = function () {
        var hexCombinations = 16777216;
        var radix = 16;
        return '#' + Math.floor(Math.random() * hexCombinations).toString(radix);
    };
    LegendService.prototype.getRandomColorRGB = function () {
        var maxRgb = 256;
        return [Math.floor(Math.random() * maxRgb), Math.floor(Math.random() * maxRgb), Math.floor(Math.random() * maxRgb)];
    };
    // Formats old simple renderers properly
    LegendService.prototype.getModifiedRenderer = function (renderer) {
        if (renderer.symbol) {
            this.convertSymbolAlphaColorToZeroToOneBased(renderer.symbol); // Older definitons may still need this prior to creation
        }
        return renderer;
    };
    LegendService.prototype.getCorrectRendererGivenGeometryType = function (geometryType, renderers) {
        var symbolType = this.getSymbolTypeFromGeometryType(geometryType);
        var rendererType = renderers[0].type;
        var filteredRenderers = [];
        switch (rendererType) {
            case 'class-breaks':
            case 'unique-value':
                var index = 0;
                if (renderers.length > 1 && geometryType === 'line') {
                    index = 1;
                }
                return renderers[index];
                break;
            case 'simple':
            default:
                filteredRenderers = renderers.filter(function (r) { return r.symbol && r.symbol.type === symbolType; });
                break;
        }
        if (filteredRenderers.length > 0) {
            return filteredRenderers[0];
        }
        else {
            //If not simple renderers, assume point first.
            var index = 0;
            if (geometryType !== 'point') {
                index = 1;
            }
            return renderers[index];
        }
        return null;
    };
    LegendService.prototype.convertSymbolJSONToSymbolDefinition = function (symbol) {
        var captialWords = /([A-Z]{1,}[a-z]*)/g;
        switch (symbol.type) {
            case 'esriSMS':
                symbol.type = 'simple-marker';
                symbol.style = symbol.style.replace('esriSMS', '').match(captialWords).join('-').toLowerCase();
                symbol.outline = this.convertSymbolJSONToSymbolDefinition(symbol.outline);
                break;
            case 'esriPMS':
                symbol.type = 'picture-marker';
                break;
            case 'esriSLS':
                symbol.type = 'simple-line';
                symbol.style = symbol.style.replace('esriSLS', '').match(captialWords).join('-').toLowerCase();
                break;
            case 'esriSFS':
                symbol.type = 'simple-fill';
                symbol.style = symbol.style.replace('esriSFS', '').match(captialWords).join('-').toLowerCase();
                symbol.outline = this.convertSymbolJSONToSymbolDefinition(symbol.outline);
                break;
            case 'esriTS':
                symbol.type = 'text';
                break;
            default:
                break;
        }
        if (symbol.style === 'null') {
            symbol.style = 'none';
        }
        this.convertSymbolAlphaColorToZeroToOneBased(symbol);
        return symbol;
    };
    LegendService.prototype.getSymbolDefinitionFromGeometry = function (geometryType, color, outlineColor) {
        if (outlineColor === void 0) { outlineColor = null; }
        var geometry = geometryType.toLowerCase();
        var size = 12;
        var borderWidth = 1;
        var lineWidth = 3;
        var outlineWidth = 1;
        switch (geometry) {
            case 'point':
            case 'multipoint':
                return this.getSimpleMarkerDefinition(color, size, color, borderWidth);
            case 'line':
            case 'polyline':
                return this.getSimpleLineDefinition(color, lineWidth);
            case 'polygon':
                if (!outlineColor) {
                    outlineColor = color;
                }
                return this.getSimpleFillDefinition(color, outlineColor, outlineWidth);
            default:
                break;
        }
    };
    LegendService.prototype.getProperSymbolDefinitonBasedOnGeometryType = function (geometryType, symbols) {
        var type = this.getSymbolTypeFromGeometryType(geometryType);
        var symbol = symbols.find(function (s) { return s.type === type; });
        return this.convertSymbolAlphaColorToZeroToOneBased(symbol);
    };
    LegendService.prototype.getExistingLayerColors = function (map) {
        var e_1, _a, e_2, _b, e_3, _c;
        var layers = map.allLayers.toArray();
        var renderers = [];
        try {
            for (var layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                var layer = layers_1_1.value;
                if (this.isMapImageLayer(layer)) {
                    try {
                        for (var _d = tslib_1.__values(layer.allSublayers.toArray()), _e = _d.next(); !_e.done; _e = _d.next()) {
                            var sublayer = _e.value;
                            renderers.push(sublayer.renderer);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
                if (this.isFeatureLayer(layer)) {
                    renderers.push(layer.renderer);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        renderers = renderers.filter(function (x) { return x; });
        var existingColors = [];
        try {
            for (var renderers_1 = tslib_1.__values(renderers), renderers_1_1 = renderers_1.next(); !renderers_1_1.done; renderers_1_1 = renderers_1.next()) {
                var renderer = renderers_1_1.value;
                if (this.isSimpleRenderer(renderer) && renderer.symbol && renderer.symbol.color) {
                    var color = renderer.symbol.color;
                    existingColors.push([color.r, color.g, color.b]);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (renderers_1_1 && !renderers_1_1.done && (_c = renderers_1.return)) _c.call(renderers_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return existingColors;
    };
    LegendService.prototype.convertSymbolAlphaColorToZeroToOneBased = function (symbol) {
        var alphaIndex = 3;
        var colorLengthWithA = 4;
        if (symbol.color && Array.isArray(symbol.color) && symbol.color.length === colorLengthWithA && symbol.color[alphaIndex] > 1) {
            var maxByteValue = 255;
            var hundred = 100;
            var value = symbol.color[alphaIndex] / maxByteValue;
            value = Math.round(value * hundred) / hundred;
            symbol.color[alphaIndex] = value;
        }
        return symbol;
    };
    LegendService.prototype.getSymbolTypeFromGeometryType = function (geometryType) {
        var type = null;
        switch (geometryType.toLowerCase()) {
            case 'point':
            case 'multipoint':
                type = 'simple-marker';
                break;
            case 'line':
            case 'polyline':
                type = 'simple-line';
                break;
            case 'polygon':
                type = 'simple-fill';
                break;
            default:
                break;
        }
        return type;
    };
    LegendService.prototype.getSimpleLineDefinition = function (color, width) {
        return {
            color: color,
            style: 'solid',
            type: 'simple-line',
            width: width
        };
    };
    LegendService.prototype.getSimpleMarkerDefinition = function (color, size, borderColor, borderWidth) {
        return {
            color: color,
            type: 'simple-marker',
            size: size,
            outline: this.getSimpleLineDefinition(borderColor, borderWidth)
        };
    };
    LegendService.prototype.getSimpleFillDefinition = function (fillColor, borderColor, borderWidth) {
        return {
            color: fillColor,
            type: 'simple-fill',
            style: 'none',
            outline: this.getSimpleLineDefinition(borderColor, borderWidth)
        };
    };
    LegendService.prototype.getCorsEnabledHosts = function () {
        // TODO: hardcode for now
        return [
            { host: 'www.dotdev7.state.pa.us/penndotgis', withCredentials: true }
        ];
    };
    LegendService.prototype.isMapImageLayer = function (layer) {
        return layer.type === 'map-image';
    };
    LegendService.prototype.isFeatureLayer = function (layer) {
        return layer.type === 'feature';
    };
    LegendService.prototype.isSimpleRenderer = function (renderer) {
        return renderer.type === 'simple';
    };
    LegendService.ngInjectableDef = i0.defineInjectable({ factory: function LegendService_Factory() { return new LegendService(); }, token: LegendService, providedIn: "root" });
    return LegendService;
}());
export { LegendService };
